//import { scenarioServices } from '@/mixins/scenarioServices.js'
import { ApiActions } from '@/api/api'

import config from '@/config/index'

const windowLocationHref = config.localhostPage || window.location.href

export default {
    //mixins: [scenarioServices],
    data() {
        return {
            scenarios: null, // сценарии
            scenarioIsShowing: false,

            scenario_unlimit_last_resend: 30, // через какое время можно безлимитно повторять сценарий без перезагрузки страницы
            scenario_employee_id: 0, // выбранный в сценарии оператор
            scenario_branch_id: 0, // выбранный в сценарии отдел
            browsing_other_tab: 0, // просматривает ли гость другую табу в браузере
            guest_events: [
                // события гостя
                'active_button_click', // 'Нажал на активную кнопку виджета'
                'trying_leave', // 'Пытается уйти с сайта' TODO
                'browsing_other_tab', // 'Начал просмотр других вкладок, не закрывая сайт'
                'scrolled_to_end' // 'Пролистал до конца страницу'
            ],
            mouse: {
                interval: 20, // Max mouse inactivity threshold, in seconds.
                time: new Date().getTime(), // Last mousemove event unixtime.

                word: 16, // Word width of selecting text, in pixels.
                line: 48, // Line height of selecting text, in pixels.
                speed: 16, // Normal cursor moving speed, in pixels per mousemove event.
                area: 128, // Width or height of quit detect area in top right window corner.
                state: 0, // Mouse button state.
                cx: 0, // Mouse cursor X coord.
                cy: 0, // Mouse cursor Y coord.

                clicking: 0, // Chance of mouse clicks.
                moving: 0, // Chance of mouse moves.
                selecting: 0, // Chance of mouse selects text.
                sleeping: 0, // Chance of mouse sleeps.
                quitting: 0 // Chance of mouse quits.
            }
        }
    },
    created() {
        if (this.$store.state.device.isMobileOnly) {
            return
        }
        this.$root.$once('scenarioInitOnce', this.scenarioInit)

        this.$root.$on(
            'scenarioBoxEffectScenarioAnimationEnd',
            this.scenarioBoxEffectScenarioAnimationEnd
        )

        this.$root.$once('hook:beforeDestroy', () => {
            this.$root.$off(
                'scenarioBoxEffectScenarioAnimationEnd',
                this.scenarioBoxEffectScenarioAnimationEnd
            )
        })
    },
    beforeDestroy() {},
    beforeCreate() {},
    methods: {
        scenarioInit() {
            window.addEventListener('scroll', this.listenerScroll)
            this.listenerScroll()
            this.listenerBrowsingOtherTab()
            this.listenerTryingLeave()
            this.listenerGuestEvents()
            this.listenerAnimationEnd()

            let scenarios = this.$store.state.api.scenarios

            /*  scenarios=null
             if (!scenarios) {
                if (process.env.VUE_APP_windowEffectWidgetScenarios)
                    window.effectWidgetScenarios = process.env.VUE_APP_windowEffectWidgetScenarios
                if (window.effectWidgetScenarios) scenarios = JSON.parse(window.effectWidgetScenarios) // на деве и в проде  переменная window.effectWidgetScenarios подливается
            }*/
            this.scenarios = scenarios
            this.scenarioLoad('init')
        },
        /**
         * Триггер события
         * @author Simon Oganesyan
         * @param name
         */
        triggerEvent(name) {
            this.$root.$emit('triggerEvent', name)
        },
        listenerScroll() {
            let scrolled = window.pageYOffset || document.documentElement.scrollTop
            if (scrolled + window.innerHeight >= document.body.clientHeight) {
                this.triggerEvent('scrolled_to_end')
            }
        },
        listenerAnimationEnd() {
            this.$root.$on('effectScenarioAnimationEnd', this.scenarioEnd)
            this.$root.$once('hook:beforeDestroy', () => {
                this.$root.$off('effectScenarioAnimationEnd')
            })
        },
        /**
         * Прослушивание событий гостя
         * @author Simon Oganesyan
         */
        listenerGuestEvents() {
            this.guest_events.forEach(name => {
                document.addEventListener(name, () => {
                    this.scenarioLoad(name)
                })
            })
        },
        /**
         * Прослушивание изменения таб в браузере
         * @author Simon Oganesyan
         */
        listenerBrowsingOtherTab() {
            let stateKey
            let eventKey
            const keys = {
                hidden: 'visibilitychange',
                webkitHidden: 'webkitvisibilitychange',
                mozHidden: 'mozvisibilitychange',
                msHidden: 'msvisibilitychange'
            }
            for (stateKey in keys) {
                if (stateKey in document) {
                    eventKey = keys[stateKey]
                    break
                }
            }

            document.addEventListener(eventKey, () => {
                const not_browsing = document[stateKey] ? 1 : 0
                this.updateBrowsingOtherTab(not_browsing)
                if (not_browsing) {
                    // TODO мерцание "Новое сообщение" в тайтле
                    // document.title = title;
                    // clearInterval(title_new_message_interval);
                }
            })
        },
        /**
         * Установка флага просмотра гостем других вкладок браузера
         * Отправка на сервер при изменении флага
         * @author Simon Oganesyan
         * @param not_browsing
         */
        updateBrowsingOtherTab(not_browsing) {
            if (not_browsing !== this.browsing_other_tab) {
                //console.log('Вкладка скрыта', !document.hidden,window.location.origin);

                ApiActions.updateBrowsingOtherTab(not_browsing)
            }
            this.browsing_other_tab = not_browsing
            if (not_browsing) {
                this.triggerEvent('browsing_other_tab')
            }
        },
        listenerTryingLeave() {
            window.addEventListener('mousemove', e => {
                const t = this.mouse,
                    s = t.state,
                    zi = t.interval * 1000,
                    z1 = t.time,
                    z2 = new Date().getTime(),
                    cx1 = t.cx,
                    cy1 = t.cy,
                    cx2 = e.clientX,
                    cy2 = e.clientY
                if (z2 - z1 < zi) {
                    if (Math.abs(cx1 - cx2) > t.speed || Math.abs(cy1 - cy2) > t.speed) {
                        t.moving += 0.1
                    }
                    if (Math.abs(cx1 - cx2) > t.word / 4 && Math.abs(cy1 - cy2) < t.line && s) {
                        t.selecting++
                    }
                    if (
                        /*cx2 > window.innerWidth-t.area &&*/ cy1 > cy2 &&
                        ((cy2 < t.area && cy1 - cy2 > t.speed / 2) ||
                            (cy2 < t.area / 2 && cy1 - cy2 > t.speed / 4) ||
                            (cy2 < t.area / 4 && cy1 - cy2 > t.speed / 8) ||
                            (cy2 < t.area / 8 && cy1 - cy2 > t.speed / 16) ||
                            (cy2 < t.area / 16 && cy1 - cy2 > t.speed / 32))
                    ) {
                        t.quitting += 0.1
                        this.triggerEvent('trying_leave')
                    }
                }

                t.cx = cx2
                t.cy = cy2
                t.time = z2
            })
        },
        /**
         * Доступен ли определенный тип онлайн-коммуникации
         * @author Simon Oganesyan
         * @param communication_type - chat/call
         * @return {boolean}
         */
        isOnlineCommunication(communication_type) {
            if (communication_type === 'chat') {
                return this.$store.state.branch.working_branches_to_chat.length
            }

            return this.$store.state.branch.working_branches_to_call.length
        },
        /**
         * Получение секунд из минут или часов
         * @param size - кол-во
         * @param type - ед. измерения
         * @returns {*}
         */
        secondsByHoursAndMinutes(size, type) {
            let seconds = size
            if (type === 1) {
                // минуты
                seconds = seconds * 60
            } else if (type === 2) {
                // часы
                seconds = seconds * 3600
            }

            return seconds
        },
        isFrameVisible() {
            return this.$store.state.chatActive
        },
        /**
         * Обработка сценариев, отобранных в php для этого гостя на этой странице
         *
         * @author Simon Oganesyan
         *
         * @param event
         */
        scenarioLoad(event) {
            if (this.scenarios && this.scenarios.length) {
                const object = {
                    func: () => {
                        const current_time = Math.floor(Date.now() / 1000)
                        let active, conditions, delay, scenario_resend_time
                        this.scenarios.forEach((scenario, index) => {
                            conditions = scenario.conditions

                            // Активируем ли сценарий
                            // Если сценарий должен сработать только по гарантии - отключаем до проверки времени
                            active = !scenario.only_guarantee

                            // Проверяем события
                            this.guest_events.forEach(guest_event => {
                                // Если события не было или оно отключено - сценарий не срабатывает
                                if (
                                    (parseInt(conditions[guest_event], 0) === 1 &&
                                        event !== guest_event) ||
                                    (parseInt(conditions[guest_event], 0) === 0 &&
                                        event === guest_event)
                                ) {
                                    active = false
                                } else if (
                                    parseInt(conditions[guest_event], 0) === 1 &&
                                    event === guest_event
                                ) {
                                    active = true
                                }

                                // Гарантированный показ для некоторых условий
                                if (
                                    !active &&
                                    parseInt(conditions[guest_event], 0) === 1 &&
                                    event !== guest_event &&
                                    parseInt(conditions.guaranteed_show_after, 0) === 1 &&
                                    ['browsing_other_tab', 'trying_leave'].indexOf(guest_event) !==
                                        -1
                                ) {
                                    scenario.only_guarantee = true
                                }
                            })

                            if (
                                active &&
                                event === 'active_button_click' &&
                                this.isFrameVisible()
                            ) {
                                active = false
                            }

                            // Проверяем событие 'Пролистал до конца страницу' на соответствие урла
                            if (
                                event === 'scrolled_to_end' &&
                                conditions.scrolled_to_end &&
                                conditions.scrolled_to_end_page.length &&
                                conditions.scrolled_to_end_page.indexOf(
                                    windowLocationHref.replace(/\/$/, '')
                                ) === -1
                            ) {
                                active = false
                            }

                            const scenario_start = this.getScenarioLoadTime(
                                scenario.id,
                                current_time
                            )
                            // Проверяем условие "Показ строго не ранее", если сценарий срабатывает первый раз за сессию
                            if (
                                active &&
                                this.getScenarioSessionOperations(scenario.id) === 0 &&
                                conditions.show_strictly_not_earlier
                            ) {
                                delay = this.secondsByHoursAndMinutes(
                                    conditions.show_strictly_not_earlier_time,
                                    conditions.show_strictly_not_earlier_time_units
                                )

                                if (!scenario_start || current_time - scenario_start < delay) {
                                    active = false
                                }
                            }

                            const last_operation_time = this.getScenarioLastSessionOperationTime(
                                scenario.id
                            )

                            // Проверяем повторную отправку
                            if (active) {
                                const operations = this.getScenarioSessionOperations(scenario.id)

                                if (parseInt(conditions.resend_message_type, 0) === 0) {
                                    // Без ограничений

                                    // через сколько можно повторить
                                    scenario_resend_time = this.scenario_unlimit_last_resend
                                } else if (parseInt(conditions.resend_message_type, 0) === 1) {
                                    // 1 раз через ...

                                    if (operations >= 2) {
                                        active = false
                                    } else {
                                        scenario_resend_time = this.secondsByHoursAndMinutes(
                                            conditions.resend_message_after,
                                            conditions.resend_message_after_time_units
                                        )
                                    }
                                } else if (parseInt(conditions.resend_message_type, 0) === 2) {
                                    // n раз с интервалом

                                    if (operations >= conditions.resend_message_count) {
                                        active = false
                                    } else {
                                        scenario_resend_time = this.secondsByHoursAndMinutes(
                                            conditions.resend_message_interval,
                                            conditions.resend_message_interval_time_units
                                        )
                                    }
                                }

                                if (
                                    scenario_resend_time &&
                                    last_operation_time &&
                                    current_time - last_operation_time < scenario_resend_time &&
                                    event !== 'active_button_click'
                                ) {
                                    active = false
                                }
                            }

                            // Если первой отработки сценария не было и подошло время гарантированного показа
                            if (
                                !active &&
                                !last_operation_time &&
                                scenario['only_guarantee'] &&
                                conditions.guaranteed_show_after
                            ) {
                                const guaranteed_show_after_time = this.secondsByHoursAndMinutes(
                                    conditions.guaranteed_show_after_time,
                                    conditions.guaranteed_show_after_time_units
                                )

                                if (current_time - scenario_start === guaranteed_show_after_time) {
                                    active = true
                                }
                            }

                            // Если повторная отправка - проверяем флаг ответа гостя на предыдущее предложение
                            if (
                                active &&
                                last_operation_time &&
                                this.wasCommunication(current_time) &&
                                parseInt(conditions.do_not_resend_to_answered, 0) === 1
                            ) {
                                active = false
                            }

                            if (active) {
                                this.showScenario(index, current_time)
                            }
                        })
                    }
                }

                if (event === 'init') {
                    setInterval(function() {
                        object.func.call(object)
                    }, 1000)
                } else {
                    object.func.call(object)
                }
            }
        },

        /**
         * Сообщение сценария
         * @author Simon Oganesyan
         * @param messages
         * @return {any}
         */
        getScenarioMessage(messages) {
            if (messages.length) {
                const name = this.$store.state.api.guest_info?.name

                if (name) {
                    messages = messages.map(message => message.replace(/\$name/g, name))
                } else {
                    messages = messages.map(message => {
                        message = message.replace(/\$name, /g, '')
                        message = message.replace(/, \$name/g, '')
                        message = message.replace(/\$name,/g, '')
                        message = message.replace(/,\$name/g, '')
                        message = message.replace(/\$name/g, '')
                        return message
                    })
                }
            }

            return messages
        },
        /**
         * id сценария последнего сообщения в чате, если это сообщение было из сценария
         * @author Simon Oganesyan
         * @return {number}
         */
        getLastMessageScenarioId() {
            let scenario_id = 0
            const last_message = this.$store.state.chat.messages[
                this.$store.state.chat.messages.length - 1
            ]
            if (last_message && last_message.scenario_id) {
                scenario_id = last_message.scenario_id
            }
            return scenario_id
        },
        /**
         * Была ли коммуникация в последнее время
         * @author Simon Oganesyan
         * @param {any} current_time
         * @return {boolean}
         */
        wasCommunication(current_time = null) {
            // Максимальное время, прошедшее с последней коммуникации гостя, в течение которого отключаются
            // сценарии с условием "Не отправлять повторно тем, кто ответил"
            const MAX_TIME_SINCE_LAST_COMMUNICATION = 259200 // 3 дня
            if (!current_time) {
                current_time = Math.floor(Date.now() / 1000)
            }
            const last = this.$store.state.localStorage.last_communication_time //Todo нет присваивания
            return last && current_time - last < MAX_TIME_SINCE_LAST_COMMUNICATION
        },
        /**
         * Сообщение серверу о срабатывании сценария
         * @author Simon Oganesyan
         * @param uuid
         * @param id
         * @param time
         * @param show был ли реально показан сценарий или должен был быть показан, но не был из-за определённых условий
         * @return {Observable<FetchResult<any>>}
         */
        operation(uuid, id, show, time = 0) {
            const scenario = this.scenarios.find(item => (item.id = id))
            this.setScenarioSessionOperations(id)
            if (!scenario.conditions.animated) {
                this.scenarioEnd(id, time)
            } else {
                this.setScenarioLastOperationTime(id, time)
            }

            if (show) {
                return ApiActions.scenarioOperation({ scenario_id: id }).then(
                    ({ data: { id } }) => {
                        this.$store.commit('scenario/setOperationId', id)
                    }
                )
            }
        },
        scenarioEnd(id, time = 0) {
            this.scenarioIsShowing = false
            this.setScenarioLastOperationTime(id, time)
        },
        /**
         * Кол-во срабатываний сценария за сессию
         * @author Simon Oganesyan
         * @param id
         * @return {number}
         */
        getScenarioSessionOperations(id) {
            let operations = 0
            let all_operations = this.$store.state.sessionStorage.scenarios_operations
            if (all_operations) {
                const index = all_operations
                    .map(function(e) {
                        return e.id
                    })
                    .indexOf(id)
                if (index > -1) {
                    operations = all_operations[index].count
                }
            }
            return operations
        },

        /**
         * Запись в сессию кол-ва срабатываний сценария
         * @author Simon Oganesyan
         * @param id
         * @return {any}
         */
        setScenarioSessionOperations(id) {
            let all_operations = this.$store.state.sessionStorage.scenarios_operations
            if (!all_operations) {
                all_operations = []
            }
            let index = all_operations
                .map(function(e) {
                    return e.id
                })
                .indexOf(id)
            if (index > -1) {
                all_operations[index].count++
            } else {
                all_operations.push({ id: id, count: 1 })
            }
            index = all_operations
                .map(function(e) {
                    return e.id
                })
                .indexOf(id)
            const count = all_operations[index].count
            this.$store.commit('setSessionStorage', ['scenarios_operations', all_operations])

            return count
        },

        /**
         * Запись в сессию времени последнего срабатывания сценария
         * @author Simon Oganesyan
         * @param id
         * @param {number} time
         * @return {number}
         */
        setScenarioLastOperationTime(id, time = 0) {
            if (!time) {
                time = Math.floor(Date.now() / 1000)
            }
            let all_operations = this.$store.state.sessionStorage.scenarios_last_operation_time
            if (!all_operations) {
                all_operations = []
            }
            let index = all_operations
                .map(function(e) {
                    return e.id
                })
                .indexOf(id)
            if (index > -1) {
                all_operations[index].time = time
            } else {
                all_operations.push({ id: id, time: time })
            }
            index = all_operations
                .map(function(e) {
                    return e.id
                })
                .indexOf(id)
            const last = all_operations[index].time
            this.$store.commit('setSessionStorage', [
                'scenarios_last_operation_time',
                all_operations
            ])

            return last
        },

        /**
         * Время последнего срабатывания сценария за сессию
         * @author Simon Oganesyan
         * @param id
         * @return {number}
         */
        getScenarioLastSessionOperationTime(id) {
            let time = 0
            let all_operations = this.$store.state.sessionStorage.scenarios_last_operation_time
            if (all_operations) {
                const index = all_operations
                    .map(function(e) {
                        return e.id
                    })
                    .indexOf(id)
                if (index > -1) {
                    time = all_operations[index].time
                }
            }
            return time
        },

        /**
         * Получение времени первой загрузки сценария
         * @author Simon Oganesyan
         * @param id
         * @param set_time
         * @return {number}
         */
        getScenarioLoadTime(id, set_time = 0) {
            let load_time = 0,
                index = -1
            let all_scenarios = this.$store.state.sessionStorage.scenarios_load_time
            if (all_scenarios) {
                index = all_scenarios
                    .map(function(e) {
                        return e.id
                    })
                    .indexOf(id)
                if (index > -1) {
                    load_time = all_scenarios[index].time
                }
            }
            if (index === -1) {
                this.setScenarioLoadTime(id, set_time)
            }
            return load_time
        },

        /**
         * Установка времени первой загрузки сценария
         * @author Simon Oganesyan
         * @param id
         * @param time
         * @return {number}
         */
        setScenarioLoadTime(id, time = 0) {
            if (!time) {
                time = Math.floor(Date.now() / 1000)
            }
            let all_scenarios = this.$store.state.sessionStorage.scenarios_load_time
            if (!all_scenarios) {
                all_scenarios = []
            }
            let index = all_scenarios
                .map(function(e) {
                    return e.id
                })
                .indexOf(id)
            if (index > -1) {
                all_scenarios[index].time = time
            } else {
                all_scenarios.push({ id: id, time: time })
            }
            index = all_scenarios
                .map(function(e) {
                    return e.id
                })
                .indexOf(id)
            const ret = all_scenarios[index].time
            this.$store.commit('setSessionStorage', ['scenarios_load_time', all_scenarios])

            return ret
        },
        /**
         * Показ сценария
         *
         * @author Simon Oganesyan
         *
         * @param scenarioId
         */
        scenarioBoxEffectScenarioAnimationEnd(scenarioId) {
            this.$root.$emit('effectScenarioAnimationEnd', scenarioId)
        },
        showScenario(index, current_time) {
            const scenario = this.scenarios[index]
            const messages = this.getScenarioMessage(scenario.conditions.message)
            const message = messages.join('\n')
            // Покажется ли сценарий
            // Покажется, если виджет закрыт или это чат и этот сценарий не был показан только что
            const show =
                !this.$store.state.active_chat_id &&
                !this.scenarioIsShowing &&
                !this.isFrameVisible() &&
                this.getLastMessageScenarioId() !== scenario.id

            const action = () => {
                if (show) {
                    // Увеличиваем каунтер срабатываний на 1 в сессии и в бд
                    this.operation(this.uuid, scenario.id, show, current_time)

                    // TODO учёт выбранных в сценарии отдела и оператора
                    //this.scenarioAssignment(index)
                    if (scenario.type === 'chat') {
                        if (scenario.conditions.animated) {
                            this.scenarioIsShowing = true
                            this.$store.commit('scenario/setBoxHelloText', messages)
                            this.$store.commit('scenario/setBoxHelloScenarioId', scenario.id)
                        } else {
                            this.$root.$emit('operatorAction')
                            this.$store.commit('setChatActiveBtn', 'chat')
                        }

                        this.$store.commit('chat/messageSend', {
                            body: message,
                            from_role_id: 6,
                            scenario_id: scenario.id
                        })
                        //this.$store.commit('actions/setOfflineConnectsOn', false) //Todo наверно не нужно
                    }

                    if (scenario.type == 'call') {
                        this.$root.$emit('operatorAction')
                        this.$store.commit('actions/setCallTextScenario', message)
                        this.$store.commit('setChatActiveBtn', 'call')
                    }
                }
            }

            if (!this.$store.state.localStorage.initStart && config.siteOptions.common.lazy_init) {
                this.$root.$once('emitHistoryIsLoadForScenarioAfterInit', () => {
                    action()
                })
                this.$root.$emit('initPointOnce')
            } else {
                action()
                /*eslint-disable */
        return;

        if (this.isOnlineCommunication(scenario.type)) {
          // если онлайн виджет
          // Показываем сценарий как сообщение

          console.log("Сообщение сценария", message);
          /*  this.$store.commit('chat/messageSend', {
                        body: message,
                        intent: scenario.type,
                        from_user_info: this.$store.state.api.employee,
                        scenario_id: scenario.id
                    })*/
        } else {
          // если оффлайн-виджет
          //this.$root.$emit('soundNewMessage')
          if (scenario.type) console.log(scenario.type, message);
          this.$root.$emit("setChatActive", true);
        }
      }
    }
  }
};
